/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo.mp4'
import fondo_img from '../../../Recursos/fondo_img.png'
import rios_cascadas from '../../../Recursos/rios_cascadas.svg'
import observacion from '../../../Recursos/observacion_silvestre.svg'
import senderos from '../../../Recursos/senderos.svg'
import {theme} from "../../../Tema";
import Tarjeta_Encontraras from "../../Tarjetas/Tarjeta_Encontraras";
import {ArrowForward} from '@mui/icons-material'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";


const Home_Portada = () => {
    const {sCell,sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <video width={'100%'} height={sCell ? 667 : sTab ? 631 : 630}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1
                   }}
                   id="background-video" autoPlay loop muted poster={fondo_img}>
                <source src={fondo} type="video/mp4"/>
            </video>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? -83.5 : -79, zIndex: 2}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        height: sCell ? 670 : 632,
                        background: 'linear-gradient(180deg, #000 0%, rgba(11, 39, 42, 0.05) 28.37%, #0B272A 100%)',
                        width: '100%'
                    }}
                >

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3, color: '#fff'}}
                    >

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'center', mt: 26}}>
                                <Typography sx={{
                                    fontSize: sCell ? 40 : 64,
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    lineHeight: 1.1,
                                    fontFamily: 'Raleway',

                                }}>Conexión con la naturaleza
                                    <br/>
                                    <span style={{
                                        fontStyle: 'italic',
                                        fontWeight: 600,
                                        paddingRight: 15,
                                        fontSize: sCell ? 32 : 54
                                    }}>Escapa</span>
                                    {sCell && <br/>}
                                    <span
                                        style={{
                                            fontStyle: 'italic',
                                            fontWeight: 600,
                                            paddingRight: 15,
                                            fontSize: sCell ? 32 : 54
                                        }}>Respira</span>

                                    <span style={{
                                        fontStyle: 'italic',
                                        fontWeight: 600,
                                        fontSize: sCell ? 32 : 54
                                    }}>Conéctate</span>
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 5}}>
                                <Typography sx={{
                                    fontFamily: 'Roboto',
                                    fontWeight: 400,
                                    color: '#C4C4C4',
                                    fontSize: 18,
                                    lineHeight: 1.2,
                                    textAlign: 'center'
                                }}>
                                    ¿Buscas un respiro del bullicio? Sumérgete en un santuario natural donde el tiempo
                                    se detiene y reconecta contigo y la naturaleza.
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                                <Button
                                    onClick={() => iniciarChatWass({mensaje: 'Hola Magaza, deseo reservar'})}
                                    endIcon={<ArrowForward/>}>Reservar Suite</Button>
                            </Grid>

                        </Grid>


                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{backgroundColor: theme.palette.primary.main}}
                >

                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{maxWidth: '1400px', px: 3, pt: 4, pb: 8}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'center'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={1}
                            >

                                <Grid container size={{xs: 12, sm: 4, md: 4}}
                                      sx={{justifyContent: 'flex-start', color: '#fff'}}>

                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={0}
                                    >

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                            <Typography sx={{
                                                fontFamily: 'Raleway',
                                                fontWeight: 800,
                                                fontSize: sCell ? 24 : 32,
                                                textAlign: sCell ? 'center' : 'left'
                                            }}>
                                                Re-ecuentrate con:
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1.5}}>
                                            <Typography sx={{
                                                fontFamily: 'Roboto',
                                                fontWeight: 400,
                                                color: '#C4C4C4',
                                                fontSize: 18,
                                                lineHeight: 1.2,
                                                textAlign: sCell ? 'center' : 'left'
                                            }}>
                                                la esencia de la naturaleza que inspira, renueva y conecta con lo más
                                                profundo de ti.
                                            </Typography>
                                        </Grid>

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent:sCell ? 'center' : 'flex-start', mt: sCell ? 2 : 1}}>
                                            <Typography
                                                onClick={() => iniciarChatWass({mensaje: 'Hola Magaza'})}
                                                sx={{fontFamily: 'Roboto', fontWeight: 600}}>
                                                MAS INFORMACION
                                            </Typography>
                                        </Grid>

                                    </Grid>

                                </Grid>


                                <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                                    <Grid
                                        container
                                        justifyContent={'flex-start'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}
                                        spacing={2}
                                    >

                                        {items.map((item, index) => (

                                            <Grid container size={{xs: 4, sm: 4, md: 4}}
                                                  sx={{justifyContent: 'center'}}>
                                                <Tarjeta_Encontraras item={item}/>
                                            </Grid>
                                        ))}

                                    </Grid>
                                </Grid>


                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>


        </Grid>
    )

}
export default Home_Portada

const items = [
    {
        img: rios_cascadas,
        nombre: 'Rios y Cascadas',
        descripcion: 'Sumérgete en el río cristalino o relájate a la orilla escuchando su murmullo'
    },
    {
        img: observacion,
        nombre: 'Observación Silvestre',
        descripcion: 'Observa aves y mamíferos en su hábitat, un paraíso natural inolvidable.'
    },
    {
        img: senderos,
        nombre: 'Senderos Mágicos',
        descripcion: 'Recorre senderos rodeados de vegetación y descubre la flora y fauna en su entorno natural.'
    },
]